

const stores = new Map();

window['storeMonior'] = stores;

const useStoreMonitor = (key, store) => {
    stores.set(Symbol(key), store);
}   

export default useStoreMonitor;